import { FormGroup } from '@angular/forms';
import { isAfter } from 'date-fns';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { NO_FUTURE_DATE, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { formPaths } from '@shared/constants/form-paths.const';
import { MySpmElemComitatoGestioneEntity } from '../../../../models/interfaces/revisione.interface';
import { checkDataFutura, controlloCaricaPresidente, validaCodiceFiscale } from '../../common/helpers/norme-validators.helper';
import {
    checkCkNormeValue,
    getSpmComitatoGestioneFormArray,
    my_SpmElemComitatoGestioneRequiredHelper,
} from './helpers/norme-spa-monistico-form-validators.helper';

export const normeSpaMonisticoComitGestRules: FormGroupRules = {
    my_SpmComitGestCarica: (form: FormGroup) => {
        const elemComitGestFormArray = getSpmComitatoGestioneFormArray(form);
        elemComitGestFormArray.controls.forEach((group: FormGroup) => {
            const my_SpmComitGestCaricaControl = getControl(group, 'my_SpmComitGestCarica');
            const errors = my_SpmComitGestCaricaControl.errors ?? {};

            addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpmComitGestCaricaControl.value), errors, 'my_SpmComitGestCarica', {
                status: REQUIRED_STATUS,
            });

            my_SpmComitGestCaricaControl.setErrors(isEqual(errors, {}) ? null : errors);
        });

        if (checkCkNormeValue(form)) {
            controlloCaricaPresidente(elemComitGestFormArray, 'my_SpmComitGestCarica');
        }
    },

    my_SpmComitGestCodFisc: (form: FormGroup) => {
        const elemComitatoGestioneFormArray = getSpmComitatoGestioneFormArray(form);

        elemComitatoGestioneFormArray.controls.forEach((group: FormGroup) => {
            const nomeUtenteControl = getControl(group, 'my_SpmComitGestNome');
            const cognomeUtenteControl = getControl(group, 'my_SpmComitGestCognome');
            const codiceFiscaleControl = getControl(group, 'my_SpmComitGestCodFisc');
            if (checkCkNormeValue(form)) {
                validaCodiceFiscale(nomeUtenteControl.value, cognomeUtenteControl.value, codiceFiscaleControl);
            }
        });
    },

    my_SpmComitGestDataElezione: (form: FormGroup) => {
        const elemComitatoGestioneFormArray = getSpmComitatoGestioneFormArray(form);
        const my_DataCompilazione: string = getControl(form, `${formPaths.conclusioni}.my_DataCompilaz`).value;

        elemComitatoGestioneFormArray.controls.forEach((group: FormGroup) => {
            const my_SpmComitGestDataElezioneControl = getControl(group, 'my_SpmComitGestDataElezione');
            const errors = my_SpmComitGestDataElezioneControl.errors ?? {};
            const dateElezione = new Date(my_SpmComitGestDataElezioneControl.value);
            const dataCompilaz = new Date(my_DataCompilazione);
            const resultLater = isAfter(dateElezione, dataCompilaz);

            addRemoveError(checkCkNormeValue(form) && resultLater && !isNilOrEmpty(dataCompilaz), errors, 'my_SpmComitGestDataElezione', {
                status: 'Data incoerente con la fine della revisione',
            });

            addRemoveError(checkCkNormeValue(form) && checkDataFutura(my_SpmComitGestDataElezioneControl.value), errors, 'my_SpmComitGestDataElezione', {
                status: NO_FUTURE_DATE,
            });

            addRemoveError(checkCkNormeValue(form) && isNilOrEmpty(my_SpmComitGestDataElezioneControl.value), errors, 'my_SpmComitGestDataElezione', {
                status: REQUIRED_STATUS,
            });

            my_SpmComitGestDataElezioneControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_SpmComitGestCognome: (form: FormGroup) => {
        my_SpmElemComitatoGestioneRequiredHelper(form, 'my_SpmComitGestCognome');
    },

    my_SpmComitGestNome: (form: FormGroup) => {
        my_SpmElemComitatoGestioneRequiredHelper(form, 'my_SpmComitGestNome');
    },

    my_SpmComitGestVia: (form: FormGroup) => {
        my_SpmElemComitatoGestioneRequiredHelper(form, 'my_SpmComitGestVia');
    },

    my_SpmComitGestProvincia: (form: FormGroup) => {
        my_SpmElemComitatoGestioneRequiredHelper(form, 'my_SpmComitGestProvincia');
    },

    my_SpmComitGestComune: (form: FormGroup) => {
        my_SpmElemComitatoGestioneRequiredHelper(form, 'my_SpmComitGestComune');
    },

    my_SpmComitGestCap: (form: FormGroup) => {
        my_SpmElemComitatoGestioneRequiredHelper(form, 'my_SpmComitGestCap');
    },
};
